import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useEffect, useReducer, useState } from "react";
import Tab from "../Tab";
import { valueTypeIcons } from "./icons";
import Icon from "../../icons";
import STooltip from "../../Tooltip";
import { SButton, SFlex } from "../../components";
const valueTypes = [
    "none",
    "block",
    "flex",
    "inline-block",
    "inline"
];
// helpt text for valueTypes
const valueTypeHelpText = {
    none: "None — hides the element.",
    block: "Block — like most elements.",
    flex: "Flex — row & column layout options.",
    inline: "Inline — like text, size cannot be set.",
    "inline-block": "Inline-block — inline, but size can be set"
};
const reducer = (state, action)=>{
    switch(action.kind){
        case "reset":
            {
                return {
                    unit: undefined
                };
            }
        case "tabSelect":
            {
                const { unit } = action;
                return {
                    ...state,
                    unit
                };
            }
    }
};
const CSSDisplayInput = ({ initialValue, defaultValue, title, propertyName, onChange, onReset, half })=>{
    const [showRefresh, setShowRefresh] = useState(false);
    const [state, dispatch] = useReducer(reducer, {
        unit: initialValue,
        defaultUnit: defaultValue
    });
    useEffect(()=>{
        const value = state.unit;
        if (value) {
            onChange(propertyName, value);
        } else {
            onReset(propertyName);
        }
    // Don't look
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        state
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: `${half ? "w-[175px]" : "grow"} pl-1 mb-1 h-7`,
        onMouseEnter: ()=>setShowRefresh(true),
        onMouseLeave: ()=>setShowRefresh(false),
        children: /*#__PURE__*/ _jsxs(SFlex, {
            direction: "row",
            gap: "2",
            grow: "1",
            justify: "between",
            align: "center",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "ml-[-0.5rem]",
                    children: /*#__PURE__*/ _jsx(SButton, {
                        "aria-label": `${propertyName} - reset`,
                        variant: initialValue == "" ? "secondary" : "primary",
                        isMinimal: initialValue == "",
                        disabled: initialValue == "",
                        size: "sm",
                        onClick: ()=>{
                            dispatch({
                                kind: "reset"
                            });
                        },
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: `flex flex-row items-center justify-center flex-grow gap-1`,
                            children: [
                                title,
                                initialValue != "" && showRefresh ? /*#__PURE__*/ _jsx(Icon, {
                                    name: "MdRefresh",
                                    size: "sm"
                                }) : null
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: `${half ? "w-[100px] absolute right-0" : "w-[293px] absolute right-0 top-0"}`,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "absolute top-[0.5px] left-[1px] right-[1px]",
                        children: /*#__PURE__*/ _jsx(SFlex, {
                            direction: "row",
                            gap: "1",
                            children: valueTypes.map((valueType)=>/*#__PURE__*/ _jsx("div", {
                                    className: "grow",
                                    children: /*#__PURE__*/ _jsx(STooltip, {
                                        size: "xs",
                                        placement: valueType.includes("inline") ? "top-end" : valueType == "none" || valueType == "block" ? "top-start" : "top",
                                        content: valueTypeHelpText[valueType],
                                        children: /*#__PURE__*/ _jsx(Tab, {
                                            $isSelected: state.unit === valueType,
                                            onClick: ()=>dispatch({
                                                    kind: "tabSelect",
                                                    unit: valueType
                                                }),
                                            "aria-label": `${propertyName} - ${valueType}`,
                                            children: valueTypeIcons[valueType]
                                        })
                                    }, valueType)
                                }, valueType))
                        })
                    })
                })
            ]
        })
    });
};
export default CSSDisplayInput;
